import { render, staticRenderFns } from "./addsupport.vue?vue&type=template&id=a9747d5e&scoped=true&"
import script from "./addsupport.vue?vue&type=script&lang=js&"
export * from "./addsupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9747d5e",
  null
  
)

export default component.exports